import { WHO_WE_ARE_IMAGE } from "../../../utils/constants";
import { getCloudinaryImageUrl } from "../../../utils/getCloudinaryImageUrl";
import Reveal from "./Reveal";

const WhoWeAre = () => (
  <section className="w-full bg-white  py-6 md:py-10 px-4 md:px-8 lg:px-10">
    <div className="mx-auto flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
      {/* left visual */}
      <Reveal className="w-full lg:w-1/2 flex-shrink-0">
        <div className="relative">
          <div className="w-full aspect-square lg:max-h-[38rem] flex items-center rounded-3xl overflow-hidden justify-center">
            <img
              className="w-full h-full object-cover "
              src={getCloudinaryImageUrl(WHO_WE_ARE_IMAGE, { width: 800 })}
              alt="WHO_WE_ARE_IMAGE"
            />
          </div>
          {/* floating badge */}
          <div
            className="absolute -bottom-5 -right-5 rounded-2xl px-5 py-4 shadow-xl"
            style={{ background: "#B3129E", minWidth: 140 }}
          >
            <p className="font-bebas text-white text-3xl leading-none">12+</p>
            <p className="text-white/80 text-xs tracking-widest uppercase mt-0.5">
              Years of
              <br />
              Excellence
            </p>
          </div>
        </div>
      </Reveal>

      {/* right content */}
      <div className="flex-1">
        <Reveal>
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#B3129E]">
            [ WHO WE ARE ]
          </span>
        </Reveal>
        <Reveal delay={100}>
          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider text-[#041122] font-semibold font-heading leading-relaxed mt-3 mb-5 ">
            Mix Masters RMC (India)
            <br />
            Pvt. Ltd.
          </h2>
        </Reveal>
        <Reveal delay={180}>
          <p className="text-descriptionText text-sm leading-relaxed text-justify mb-5">
            Mix Masters is a new-age ready-mix concrete company built by
            professionals with deep domain experience and a strong execution
            mindset. Founded with the objective of redefining reliability and
            quality in the RMC ecosystem, Mix Masters combines robust
            operational discipline, process-driven manufacturing, and
            customer-centric service delivery.
          </p>
          <p className="text-descriptionText text-sm leading-relaxed text-justify mb-8">
            With more than 12 years of industry experience, we have positioned
            ourselves as a frontrunner in the sector — delivering customized
            solutions that cater to the changing demands of contemporary
            construction across Odisha and beyond.
          </p>
        </Reveal>

        {/* Mission / Vision cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
          <Reveal delay={240}>
            <div className="rounded-2xl p-5 bg-[#f9f5ff] border border-[#ede9fe] h-full">
              <h3 className="font-bold text-headingText mb-2 text-sm">
                Our Mission
              </h3>
              <p className="text-descriptionText text-xs leading-relaxed">
                To become a leader in ready-mix concrete by providing
                technologically advanced, environmentally friendly, and
                customizable solutions that guarantee quality and efficiency for
                every project.
              </p>
            </div>
          </Reveal>
          <Reveal delay={320}>
            <div className="rounded-2xl p-5 bg-[#f5f5f8] border border-[#e8e8ee] h-full">
              <h3 className="font-bold text-headingText mb-2 text-sm">
                Our Vision
              </h3>
              <p className="text-descriptionText text-xs leading-relaxed">
                We aspire to be acknowledged as the most reliable and innovative
                brand in concrete — dedicated to sustainability and excellence,
                while reshaping the construction industry.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
export default WhoWeAre;
